import {useMapContext} from '@/components/MindMap/index.mjs'
import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import TagSelect from '../../SidePanel/RightPanel/PropertiesControllerTagSelect.jsx'
import Model from './ModelBdlogic.mjs'
import getRuleType from './RuleType.jsx'
import ButtonMakeSf from './PropertiesPaneButtonMakeSf.jsx'

const PropertiesPaneBatchBdlogic = (props) => {
    const map = useMapContext()
    const RuleType = getRuleType(map)

    return (
        <PropertiesPane
            buttons={<ButtonMakeSf />}

            controllers={
                <>
                    <Select
                        options={RuleType}
                        prop="ruleType"
                    />

                    <TagSelect prop="ruleKey" />
                </>
            }

            Model={Model}
            {...props}
        />
    )
}

export default PropertiesPaneBatchBdlogic
